import { TableColumn } from '../shared/table/table.component';

export const SharedInfoColumns: TableColumn[] = [
  {
    field: 'user',
    caption: 'SHARE_INFO_TABLE.USER',
    type: 'regular',
  },
  {
    field: 'email',
    caption: 'Email',
    type: 'regular',
  },
  {
    field: 'company',
    caption: 'SHARE_INFO_TABLE.COMPANIES',
    type: 'regular',
  },
  {
    field: 'shared',
    caption: 'SHARE_INFO_TABLE.SECTIONS_SHARED',
    type: 'regular',
  },
  {
    field: 'actions',
    type: 'icon-multi-action',
    caption: 'SHARE_INFO_TABLE.ACTIONS',
    multiActionIcons: [
      {
        icon: 'edit',
        actionType: 'edit',
        actionTitle: 'LABELS.EDIT',
      },
      {
        actionType: 'delete',
        icon: 'delete_forever',
        actionTitle: 'LABELS.DELETE',
      },
    ],
  },
];

export const SharedDocsColumns: TableColumn[] = [
  {
    field: 'user',
    caption: 'SHARE_INFO_TABLE.USER',
    type: 'regular',
  },
  {
    field: 'email',
    caption: 'Email',
    type: 'regular',
  },

  {
    field: 'shared',
    caption: 'SHARE_INFO_TABLE.DOC_SHARED',
    type: 'regular',
  },
  {
    field: 'company_name',
    caption: 'SHARE_INFO_TABLE.COMPANY_NAME',
    type: 'regular',
  },
  {
    field: 'actions',
    type: 'icon-multi-action',
    caption: 'SHARE_INFO_TABLE.ACTIONS',
    multiActionIcons: [
      {
        actionType: 'delete',
        icon: 'delete_forever',
        actionTitle: 'LABELS.DELETE',
      },
    ],
  },
];

export const ShareInfoTableES = {
  USER: 'Usuario',
  COMPANIES: 'Sociedades',
  SECTIONS_SHARED: 'Secciones Compartidas',
  ACTIONS: 'Acciones',
  DESCRIPTION:
    'Compartí información de tus sociedades con usuarios externos. Seleccioná qué módulos y documentos puede ver cada usuario invitado.',
  SELECTION: 'Seleccione la información a compartir',
  DOC_SHARED: 'Carpeta / Documento Compartido',
  COMPANY_PANEL: 'Panel Societario',
  LIBRARY: 'Biblioteca',
  COMPANY_NAME: 'Nombre de la Sociedad',
};

export const ShareInfoTableEN = {
  USER: 'User',
  COMPANIES: 'Companies',
  SECTIONS_SHARED: 'Shared sections',
  ACTIONS: 'Actions',
  DESCRIPTION:
    'Share your company information with external users. Select which modules and documents each invited user can access.',
  SELECTION: 'Select the information you want to share',
  DOC_SHARED: 'Folder / File Shared',
  COMPANY_PANEL: 'Corporate Panel',
  LIBRARY: 'Library',
  COMPANY_NAME: 'Company Name',
};

export interface CompanyShared {
  user: string;
  email: string;
  companies: string;
  shared: string;
}

export interface DocShared {
  user: string;
  email: string;
  shared: string;
  filemanager_guid: string;
  company_name: string;
}

export interface User {
  id: string;
  name: string;
  email: string;
  description: string;
}

export interface Company {
  id: string;
  name: string;
  description: string;
}
